module.exports = __webpack_public_path__ + "images/newerp_icon1.1790221230673.png";